import config from '@/config'

const { page } = config
export default {
  data () {
    return {
      tableLoading: false,
      submitLoading: false,
      page1: { ...page }, // mixin中的对象必须保证是单独的，如果引用同一份，则变成 引用传递导致所有页面共用一份
      page2: { ...page }
    }
  },
  created () {
  },
  methods: {
    // initMixinData () {
    //   this.page1 = this.$config.page
    //   this.page2 = this.$config.page
    // }
  }
}
